import { Text } from "@growtherapy/sprout-ui";
import { ModifiedToastAria, Toast, ToastVariant } from "../../toasts";
import { ToastButton } from "../../toasts/ToastButton";
import { CSSRPromptText } from "./constants";

type CSSRSPromptToastProps = {
  patientName: string;
  onAdministerCSSRS: () => void;
} & ModifiedToastAria;

export function CSSRSPromptToast({
  contentProps,
  titleProps,
  descriptionProps,
  patientName,
  onAdministerCSSRS,
  ...toastAriaProps
}: CSSRSPromptToastProps) {
  return (
    <Toast
      alignment="top"
      className="max-w-4xl w-full sm:w-full"
      closeButtonSize="sm"
      variant={ToastVariant.Error}
      {...toastAriaProps}
    >
      <div className="flex flex-1 flex-wrap md:flex-nowrap justify-start gap-3 min-w-0">
        <div className="flex flex-col min-w-0 w-max gap-1" {...contentProps}>
          <Text as="h3" className="font-medium" {...titleProps}>
            {CSSRPromptText.HEADING}
          </Text>
          <Text as="span" className="text-sm" {...descriptionProps}>
            <span className="fs-exclude data-dd-privacy">
              {`${patientName || "Your client"}`}
            </span>{" "}
            {`${CSSRPromptText.BODY}`}
          </Text>
        </div>

        <ToastButton use="secondary" onClick={onAdministerCSSRS}>
          {CSSRPromptText.CALL_TO_ACTION}
        </ToastButton>
      </div>
    </Toast>
  );
}
